import { WSContainer } from "@wingspanhq/fe-component-library";
import { WingspanProductAspects } from "@wingspanhq/users/dist/lib/interfaces";
import * as React from "react";
import { useHistory } from "react-router-dom";
import { BrowserPageTitle } from "../../components/BrowserPageTitle/BrowserPageTitle";
import { useUserId } from "../../query/hooks/helpers";
import {
  useUpdateActivity,
  useUpdateMemberProfile
} from "../../query/users/mutations";
import { useMemberProfile } from "../../query/users/queries";
import { OnboardingHeader } from "../components/OnboardingHeader/OnboardingHeader";
import { OnboardingQuestion } from "../components/OnboardingQuestion/OnboardingQuestion";

interface OnboardingStep3BenefitsProps {}

export const OnboardingStep3Benefits: React.FC<OnboardingStep3BenefitsProps> = () => {
  const history = useHistory();
  const userId = useUserId();
  const [updateActivity, updateActivityMeta] = useUpdateActivity(userId);
  const qMember = useMemberProfile(userId);
  const [
    updateMemberProfile,
    updateMemberProfileMeta
  ] = useUpdateMemberProfile();
  const onBack = () => {
    history.push("/member/onboarding/step/2");
  };
  const onSubmit = async (data: any) => {
    await updateMemberProfile({
      memberId: qMember.data?.memberId as string,
      profile: {
        productAspectImportance: [data.productAspectImportance]
      }
    });
    await updateActivity({
      flows: {
        onboarding: {
          version: 3,
          currentStep: 4,
          totalSteps: 4,
          complete: false
        }
      }
    });
    history.push("/member/onboarding/step/4/benefits");
  };
  return (
    <>
      <BrowserPageTitle title="Onboarding: Step 3 | Benefits" />
      <OnboardingHeader onBack={onBack} />
      <WSContainer verticalPadding>
        <OnboardingQuestion
          name="productAspectImportance"
          question={{
            question: "What could be better?",
            options: [
              {
                label: "Finding health insurance",
                value: WingspanProductAspects.HealthInsurance,
                virtualAssistantMsg:
                  "Health insurance is HARD. The Wingspan insurance team will work with you to navigate the complexities of finding and purchasing health insurance.",
                ctaBtnText: "Try Benefits"
              },
              {
                label: "Saving money on medical bills",
                value: WingspanProductAspects.SavingMoneyOnMedicine,
                virtualAssistantMsg:
                  "Skip the doctor and get free 24/7 access to virtual care, 1:1 support negotiating insurance bills, savings on prescriptions, and more included in your Wingspan Membership.",
                ctaBtnText: "Try Benefits"
              },
              {
                label: "Legal and financial support",
                value: WingspanProductAspects.LegalAndFinancialSupport,
                virtualAssistantMsg:
                  "Through Wingspan, you can get help with basic legal matters and work with a financial wellness coach to guide you through life’s toughest logistics.",
                ctaBtnText: "Try Benefits"
              },
              {
                label: "Mind and body support",
                value: WingspanProductAspects.MindAndBodySupport,
                virtualAssistantMsg:
                  "Get discounts on alternative medicine and chiropractic through Wingspan. Keep an eye out for Therapy Benefits as well, coming soon!",
                ctaBtnText: "Try Benefits"
              }
            ]
          }}
          onSubmit={onSubmit}
          isSubmitting={
            updateMemberProfileMeta.isLoading || updateActivityMeta.isLoading
          }
          defaultValues={{
            productAspectImportance:
              qMember.data?.profile.productAspectImportance?.[0]
          }}
        />
      </WSContainer>
    </>
  );
};
